import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"
import NumericFilter from "../../../components/ParadigmaTable/NumericFilter"
import { format } from '../../../functions/functions';
import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import moment from 'moment';

class Gastos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Moneda",
                    id: "moneda",
                    accessor: "moneda",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => moment(d.fecha).format('DD-MM-YYYY'),
                    className: "text-center",
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />,
                    show: true,
                },
                {
                    Header: "Loteo",
                    id: "loteo",
                    lookup: "nombre__icontains",
                    accessor: d => (d.loteo) ? (d.loteo.nombre) : (' ... '),
                    show: true,
                },
                {
                    Header: "Obra",
                    id: "obra",
                    lookup: "titulo__icontains",
                    accessor: d => d.obra ? d.obra.titulo : '',
                    show: true,
                },
                {
                    Header: "Rubro",
                    id: "rubro",
                    lookup: "nombre__icontains",
                    accessor: d => d.rubro.nombre,
                    show: true,
                },
                {
                    Header: "Proveedor",
                    id: "proveedor",
                    lookup: "nombre__icontains",
                    accessor: d => d.proveedor.nombre,
                    show: true,
                },
                {
                    Header: "Comprobante",
                    id: "comprobante",
                    accessor: d => d.comprobante,
                    show: true,
                },
                {
                    Header: "Descripción",
                    id: "descripcion",
                    accessor: d => d.descripcion,
                    show: false,
                },
                {
                    Header: "Monto",
                    id: "monto",
                    className: 'monto',
                    accessor: d => `${d.moneda.simbolo} ${format(d.monto)}`,
                    show: true,
                    Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={onChange}/>
                },
                {
                    Header: "Recibo",
                    id: "tipoComprobante",
                    accessor: (d) =>
                            <a
                                className="ui-table-link"
                                href={
                                    api.obras.gastosRecibo + d.id +
                                    "/"
                                }
                                target="_blank"
                            >
                                Recibo 
                            </a>,
                    show: true,
                    className: "text-center",
                    filterable: false,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'obras_gastos_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'obras_gastos_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'obras_gastos_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'obras_gastos_delete',
                    }
                ]}
                depth={3}
                apiUrl={api.obras.gastos}
                columns={this.state.columns}
                exportUrl={api.obras.gastos}
                title={"Gastos"}
            />
        );
    }
}

export default Gastos;



// WEBPACK FOOTER //
// ./src/views/Obras/Gastos/Gastos.js